// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event){

    //wait until images, links, fonts, stylesheets, and js is loaded
    window.addEventListener("load", function() {

        // Get thank you page URL from data attribute
        const raisenowBlock = document.querySelector('.raisenow');
        const customThankYouPage = raisenowBlock ? raisenowBlock.getAttribute('data-thank-you-url') : 'https://specialolympics.ch/spenden/vielen-dank-fuer-ihre-spende/';
        
        //Initialize RaiseNow Widget
        (dataLayer = window.dataLayer || []).push({
            customThankYouPage: customThankYouPage
        });
            window.rnw.tamaro.events["purposeChanged"].subscribe(function (event) {
            let widgetData = event.data.api.paymentForm.data;
            switch (widgetData.purpose) {
            case "purpose1":
            widgetData.purpose1 = 'Sportangebote für Menschen mit Beeinträchtigung (verschiedene Beträge)';
            break;
            default:
            break;
        }
        });

            window['rnw']['tamaro'].events["paymentComplete"].subscribe(function (event) {
            let widget = window['widget'] = event.data.api;

            if (!window.google_tag_manager) {
            if (widget.transactionInfo.epayment_status === 'success') {
                const urlSeparator = customThankYouPage.includes('?') ? '&' : '?';
                let redirectUrl = customThankYouPage + urlSeparator + 'rnwDonatedAmount=' + widget.paymentForm.data.amount;
                
                if (widget.transactionInfo.epp_transaction_id && widget.transactionInfo.payment_method === 'ezs') {
                    redirectUrl += '&rnwTransactionId=' + widget.transactionInfo.epp_transaction_id;
                }
                
                window.location = redirectUrl;
                try {
                    widget.element.hide();
                } catch (e) {
                }
            }

            if (widget.transactionInfo.epayment_status !== 'success') {
            window.location = 'https://donate.specialolympics.ch/template-donation-error/';
        }
        }
        });

            window['rnw']['tamaro'].events["subscriptionCancelled"].subscribe(function (event) {
            window.location = 'https://donate.specialolympics.ch/template-subscription-cancel/';
        });

            window['rnw']['tamaro'].events["subscriptionUpdateComplete"].subscribe(function (event) {
            window.location = 'https://donate.specialolympics.ch/template-subscription-update/';
        });

        // Get language from data attribute (raisenowBlock already retrieved above)
        let widgetLanguage = raisenowBlock ? raisenowBlock.getAttribute('data-lang') : 'de';
        
        // Fallback: check HTML lang attribute
        if (!widgetLanguage || widgetLanguage === '') {
            const htmlLang = document.documentElement.lang;
            widgetLanguage = htmlLang ? htmlLang.split('-')[0] : 'de';
        }

        window.rnw.tamaro.runWidget('.rnw-widget-container', {
            paymentWidgetBlocks: [
            "payment_amounts_and_intervals",
            "payment_payment_methods",
            "payment_profile",
            "payment_address",
            ],
            language: widgetLanguage,
            recurringIntervals: [
            "yearly",
            "quarterly",
            "semestral",
            "monthly",
            ],
            paymentFormPrefill: {
            stored_show_purpose_step: false, // hide purpose step
            purpose1: 'Sportangebote für Menschen mit Beeinträchtigung (verschiedene Beträge)',
        },
            translations: {
            'de': {
        }
        },
            amounts: [
            50,
            100,
            20,
            ],
            defaultAmount: 100,
        }).then(function (api) {
            window.api = api;
        });
    }, false);

});